export default __webpack_public_path__ + "static/first-ec768e0279b3ef887abf526b5bb33029.svg";